<template>
    <div class="league_tab">
        <div class="container">
            <router-link tag="div" to="/ArtubeLeague" class="tab on"><p>아튜브리그</p></router-link>
            <!-- <router-link tag="div" to="/ArtubeLeague/challenge" class="tab"><p>도전리그</p></router-link> -->
            <a class="upload" @click="uploadWebtoon" v-if="!isShowWebtoonUpload">웹툰 올리기</a>
        </div>
        <Login :initIsShowPopup="isShowLoginPopup" @loginComplete="loginComplete" @close="close('Login')" />
        <PopupOK :initIsShowPopup="isShowPopupOkPopup" :initPopupOkMessage="initPopupOkMessage" @close="close('PopupOk')" />
    </div>
</template>

<script>
import Login from '@/components/Login.vue'
import PopupOK from '@/components/PopupOK.vue'

export default {
    name: 'LeagueTab',
    components: {
        Login,
        PopupOK,
    },
    data(){
        return {
            isShowLoginPopup: false,
            isShowWebtoonUpload: false,

            isShowPopupOkPopup: false,
            initPopupOkMessage: '',
            PopupOkCallbakPage: '',    // 확인 팝업에서 확인 버튼 눌렀을때 이동할 페이지
        }
    },
    props: {
    },
    async created() {
        this.isShowWebtoonUpload = this.mobileCheck();
        await this.mixinSiteConfigCheck();
        await this.mixinLoginCheck();
    },
    mounted(){
    },
    beforeDestroy() {
	},
    methods: {
        async uploadWebtoon(){
            if(this.$store.state.loginCheck === false){ //로그인 확인
                this.isShowLoginPopup = true;
            }else if(!this.$store.state.adult){ //성인 인증 확인
                var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;
                window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
            }
            else{
                var checkWriter = await this.checkWriter(); //작가 등록 여부 확인
                if(checkWriter === null){   //체크 에러
                    this.initPopupOkMessage = '작가 등록 여부 체크 에러'
                    // this.PopupOkCallbakPage = 'reload';
                    this.isShowPopupOkPopup = true;
                }
                else if(checkWriter){   //작가 등록된 상태
                    this.$router.push('/LeagueMypage')
                }
                else{   //작가 등록 안된 상태
                    this.$router.push('/Enrollment')
                }
            }
        },
        async checkWriter(){
            var param = 
            {
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1: 0
            }
            return await this.$Axios.post(`${this.league_host}/challenge/writer/check`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    return true;
                }
                else if(res.data.returnCode === 41){
                    return false;
                }
                else{
                    return null;
                }
            })
            .catch((error) => {
                console.log(error);
                return null;
            });
        },
        loginComplete(){
            this.isShowLoginPopup = false;
        },
        close(popupType){
            switch(popupType){
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
                case 'PopupOk':
                    this.isShowPopupOkPopup = false;
                    if(this.PopupOkCallbakPage === 'reload'){
                        location.reload();
                    }
                    else if(this.PopupOkCallbakPage !== ''){
                        this.$router.push(this.PopupOkCallbakPage);
                    }
                    this.PopupOkCallbakPage = '';
                    break;
            }
        }
    },
}
</script>